import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import LearningObjectiveCheckItem from "@/components/storyboard/text/LearningObjectiveCheckItem";
import LearningObjectiveCheckList from "@/components/storyboard/text/LearningObjectiveCheckList";
import type { TextLearningObjectiveQuestionData } from "@/types/storyboard";

interface Props {
  data: TextLearningObjectiveQuestionData;
}

/**
 * Learning-objective questions as a check-marked list — accent surface
 * matching summary/info blocks.
 */
export const TextLearningObjectiveQuestion = ({ data }: Props) => {
  return (
    <ContentBlock title={data.introduction || "Lernzielfrage"} tone="emphasis">
      <LearningObjectiveCheckList>
        {data.questions?.map((question, index) => (
          <LearningObjectiveCheckItem key={index}>
            <CourseMarkdown>{question}</CourseMarkdown>
          </LearningObjectiveCheckItem>
        ))}
      </LearningObjectiveCheckList>
    </ContentBlock>
  );
};
